import React, { memo } from "react";

import Icon from "app/components/Icon/Icon";
import { ReactComponent } from "./svgs/inconclusive_test_flows.svg";

export const InconclusiveTestFlowsIcon = memo(() => {
  return <Icon component={ReactComponent} />;
});
